import BaseApiService from "@/core/services/apiServices/BaseApiService";
import JwtService from "@/core/services/JwtService";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { Actions, Mutations } from "../enums/StoreEnums";

@Module
export default class DashboardModule extends VuexModule {
    isDashboard = false
    get isDashboardPage() { return this.isDashboard; }
    @Mutation
    [Mutations.SET_IS_DASHBOARD](isDashboard: boolean) {
        this.isDashboard = isDashboard;
    }

    dataFetched = false
    get isDataFetched() { return this.dataFetched }
    @Mutation
    [Mutations.SET_DASHBOARD_DATA_FETCHED](fetched: boolean) {
        this.dataFetched = fetched
    }

    //#region JobState
    faultedJobCount = 0;
    pendingJobCount = 0;
    retriedJobCount = 0;
    runningJobCount = 0;
    stoppedJobCount = 0;
    successfulJobCount = 0;

    get getFaultedJobCount() { return this.faultedJobCount; }
    get getPendingJobCount() { return this.pendingJobCount; }
    get getRetriedJobCount() { return this.retriedJobCount; }
    get getRunningJobCount() { return this.runningJobCount; }
    get getStoppedJobCount() { return this.stoppedJobCount; }
    get getSuccessfulJobCount() { return this.successfulJobCount; }

    @Mutation
    [Mutations.SET_FAULTED_JOB_COUNT](count: number) {
        this.faultedJobCount = count
    }
    @Mutation
    [Mutations.SET_PENDING_JOB_COUNT](count: number) {
        this.pendingJobCount = count
    }
    @Mutation
    [Mutations.SET_RETRIED_JOB_COUNT](count: number) {
        this.retriedJobCount = count
    }
    @Mutation
    [Mutations.SET_RUNNING_JOB_COUNT](count: number) {
        this.runningJobCount = count
    }
    @Mutation
    [Mutations.SET_STOPPED_JOB_COUNT](count: number) {
        this.stoppedJobCount = count
    }
    @Mutation
    [Mutations.SET_SUCCESSFULL_JOB_COUNT](count: number) {
        this.successfulJobCount = count
    }
    //#endregion JobState

    //#region Process
    processPackageCount = 0;
    libraryPackageCount = 0;

    get getProcessPackageCount() { return this.processPackageCount; }
    get getLibraryPackageCount() { return this.libraryPackageCount; }

    @Mutation
    [Mutations.SET_PROCESS_PACKAGE_COUNT](count: number) {
        this.processPackageCount = count
    }
    @Mutation
    [Mutations.SET_LIBRARY_PACKAGE_COUNT](count: number) {
        this.libraryPackageCount = count
    }
    //#endregion Process

    //#region Machine
    machineCount = 0;

    get getMachineCount() { return this.machineCount; }

    @Mutation
    [Mutations.SET_MACHINE_COUNT](count: number) {
        this.machineCount = count
    }
    //#endregion Machine

    //#region RobotStatus
    onlineRobotCount = 0;
    busyRobotCount = 0;
    unresponsiveRobotCount = 0;

    get getOnlineRobotCount() { return this.onlineRobotCount; }
    get getBusyRobotCount() { return this.busyRobotCount; }
    get getUnresponsiveRobotCount() { return this.unresponsiveRobotCount; }

    @Mutation
    [Mutations.SET_ONLINE_ROBOT_COUNT](count: number) {
        this.onlineRobotCount = count
    }
    @Mutation
    [Mutations.SET_BUSY_ROBOT_COUNT](count: number) {
        this.busyRobotCount = count
    }
    @Mutation
    [Mutations.SET_UNRESPONSIVE_ROBOT_COUNT](count: number) {
        this.unresponsiveRobotCount = count
    }
    //#endregion RobotStatus

    //#region RobotType
    studioRobotCount = 0;
    unattendedRobotCount = 0;

    get getStudioRobotCount() { return this.studioRobotCount; }
    get getUnattendedRobotCount() { return this.unattendedRobotCount; }

    @Mutation
    [Mutations.SET_STUDIO_ROBOT_COUNT](count: number) {
        this.studioRobotCount = count;
    }
    @Mutation
    [Mutations.SET_UNATTENDED_ROBOT_COUNT](count: number) {
        this.unattendedRobotCount = count;
    }
    //#endregion RobotType

    @Action
    [Actions.SET_DASHBOARD_DATA](data) {
        const agentData = data.agent_dashboard.data
        const orchData = data.orch_dashboard.data

        this.context.commit(Mutations.SET_DASHBOARD_DATA_FETCHED, true)
        if (agentData) {
            this.context.dispatch(Actions.SET_JOB_STATISTICS, agentData.job)
            this.context.dispatch(Actions.SET_PACKAGE_STATISTICS, agentData.package)
        }

        if (orchData) {
            this.context.commit(Mutations.SET_MACHINE_COUNT, orchData.machine)
            this.context.dispatch(Actions.SET_ROBOT_STATUS_STATISTICS, orchData.robot)
        }
    }

    @Action
    [Actions.SET_JOB_STATISTICS](jobStatistics) {
        if (jobStatistics) {
            this.context.commit(Mutations.SET_FAULTED_JOB_COUNT, jobStatistics.faulted);
            this.context.commit(Mutations.SET_PENDING_JOB_COUNT, jobStatistics.pending);
            this.context.commit(Mutations.SET_RETRIED_JOB_COUNT, jobStatistics.retried);
            this.context.commit(Mutations.SET_RUNNING_JOB_COUNT, jobStatistics.running);
            this.context.commit(Mutations.SET_STOPPED_JOB_COUNT, jobStatistics.stopped);
            this.context.commit(Mutations.SET_SUCCESSFULL_JOB_COUNT, jobStatistics.successful);
        }
    }

    @Action
    [Actions.SET_PACKAGE_STATISTICS](packageStatistics) {
        if (packageStatistics) {
            this.context.commit(Mutations.SET_LIBRARY_PACKAGE_COUNT, packageStatistics.library);
            this.context.commit(Mutations.SET_PROCESS_PACKAGE_COUNT, packageStatistics.process);
        }
    }

    @Action
    [Actions.SET_ROBOT_STATUS_STATISTICS](robotStatistics) {
        if (robotStatistics) {
            if (robotStatistics.status) {
                this.context.commit(Mutations.SET_BUSY_ROBOT_COUNT, robotStatistics.status.busy);
                this.context.commit(Mutations.SET_ONLINE_ROBOT_COUNT, robotStatistics.status.online);
                this.context.commit(Mutations.SET_UNRESPONSIVE_ROBOT_COUNT, robotStatistics.status.unresponsive);
            }
            if (robotStatistics.type) {
                this.context.commit(Mutations.SET_UNATTENDED_ROBOT_COUNT, robotStatistics.type.unattended);
                this.context.commit(Mutations.SET_STUDIO_ROBOT_COUNT, robotStatistics.type.studio);
            }
        }
    }

    @Action
    [Actions.INIT_DASHBOARD_STATISTICS](force = false) {
        if (JwtService.getUser()) {
            if (force || (!this.dataFetched || this.isDashboard)) {
                setTimeout(() => {
                    BaseApiService.GetDashboardData();
                }, 500);
            }
        }
    }
}